import { Clipboard } from '@capacitor/clipboard';

export const ClipboardUtil = {
  async copyText(input: string | string[]) {
    const text = Array.isArray(input) ? input.join('\n') : input;
    return Clipboard.write({ string: text });
  },
};
